//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Components
import Block from "./Block"

const { Container, Wrapper, Binocle, Lifibuoy, Diving } = style

const BlockTravel = ({ blocks = [] }) => {
  return (
    <div className={Container}>
      <div className={Wrapper}>
        <div className={Lifibuoy}></div>
        <div className={Diving}></div>
        {blocks.map((item, index) => (
          <Block {...item} key={index}></Block>
        ))}
      </div>
    </div>
  )
}

export default BlockTravel
